import { View } from '@adobe/react-spectrum';
import React, { FC, useEffect, useState } from 'react';
import { SystemEvent } from '~/Scene/System/system';
import { CanvasEvent, canvasObservable } from '~/Services/Studio/Canvas/canvasObservable';
import { _system } from '~/Services/Studio/studioScene';

export const CanvasFrame: FC = () => {
    const [show, setShow] = useState(false);
    const [min, setMin] = useState(0);

    useEffect(() => {
        canvasObservable.on(CanvasEvent.ShowFrame, () => {
            setShow(true);
        });
        _system.on(SystemEvent.Resize, () => {
            const parent = _system.canvas.parentNode;
            setMin((Math.min(parent.clientWidth, parent.clientHeight) * 0.878));
        });
        canvasObservable.on(CanvasEvent.HideFrame, () => {
            setShow(false);
        });
    }, []);

    if (!show) {
        return (<></>);
    }

    return (
        <View
            borderColor="red-600"
            borderWidth="thick"
            borderRadius="medium"
            width={min}
            height={min}
            position="absolute"
            top="50%"
            left="50%"
            zIndex={1}
            UNSAFE_style={{
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none'
            }}
        >
            <></>
        </View>
    );
};
